import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uploading-file-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_item = _resolveComponent("file-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_file_item, { file: _ctx.customFile }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.status), 1)
      ]),
      _: 1
    }, 8, ["file"]),
    _createElementVNode("div", {
      class: "file-upload-progress",
      style: _normalizeStyle(_ctx.style)
    }, null, 4)
  ]))
}